var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13080_12538)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.41669 4.08317H7.58335V5.24984H6.41669V4.08317ZM6.41669 6.4165H7.58335V9.9165H6.41669V6.4165ZM7.00002 1.1665C3.78002 1.1665 1.16669 3.77984 1.16669 6.99984C1.16669 10.2198 3.78002 12.8332 7.00002 12.8332C10.22 12.8332 12.8334 10.2198 12.8334 6.99984C12.8334 3.77984 10.22 1.1665 7.00002 1.1665ZM7.00002 11.6665C4.42752 11.6665 2.33335 9.57234 2.33335 6.99984C2.33335 4.42734 4.42752 2.33317 7.00002 2.33317C9.57252 2.33317 11.6667 4.42734 11.6667 6.99984C11.6667 9.57234 9.57252 11.6665 7.00002 11.6665Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13080_12538"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.df4765395ed91a0b13ca40ab4e9b0c98.svg";
export { ForwardRef as ReactComponent };